/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Unknown_OrgInputs */

const th_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบองค์กรนี้`)
};

const en_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That organisation does not exist.`)
};

const ja_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この団体は存在しません。`)
};

const zh_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该组织不存在。`)
};

const es_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa organización no existe.`)
};

const pt_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa organização não existe.`)
};

const id_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisasi itu tidak ada.`)
};

const fr_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette organisation n’existe pas.`)
};

const tl_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang organisasyong iyon.`)
};

const vi_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có tổ chức đó.`)
};

const ko_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 조직은 없습니다.`)
};

const de_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Organisation gibt es nicht.`)
};

const ru_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такой организации нет.`)
};

const tr_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir kuruluş yok.`)
};

const it_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'organizzazione non esiste.`)
};

const pl_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taka organizacja nie istnieje.`)
};

const uk_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такої організації немає.`)
};

const hi_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह संगठन मौजूद नहीं है।`)
};

const ar_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك المؤسسة غير موجودة.`)
};

const ms_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisasi itu tidak wujud.`)
};

const bn_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই সংস্থা নেই।`)
};

const zh_tw2_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該組織不存在。`)
};

const zh_hk2_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該組織不存在。`)
};

const ur_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ ادارہ موجود نہیں۔`)
};

const fa_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین سازمانی وجود ندارد.`)
};

const sw_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shirika hilo halipo.`)
};

const nl_err_unknown_org = /** @type {(inputs: Err_Unknown_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die organisatie bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That organisation does not exist." |
*
* @param {Err_Unknown_OrgInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_unknown_org = /** @type {((inputs?: Err_Unknown_OrgInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Unknown_OrgInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_unknown_org(inputs)
	if (locale === "ja") return ja_err_unknown_org(inputs)
	if (locale === "zh") return zh_err_unknown_org(inputs)
	if (locale === "es") return es_err_unknown_org(inputs)
	if (locale === "pt") return pt_err_unknown_org(inputs)
	if (locale === "id") return id_err_unknown_org(inputs)
	if (locale === "fr") return fr_err_unknown_org(inputs)
	if (locale === "tl") return tl_err_unknown_org(inputs)
	if (locale === "vi") return vi_err_unknown_org(inputs)
	if (locale === "ko") return ko_err_unknown_org(inputs)
	if (locale === "de") return de_err_unknown_org(inputs)
	if (locale === "ru") return ru_err_unknown_org(inputs)
	if (locale === "tr") return tr_err_unknown_org(inputs)
	if (locale === "it") return it_err_unknown_org(inputs)
	if (locale === "pl") return pl_err_unknown_org(inputs)
	if (locale === "uk") return uk_err_unknown_org(inputs)
	if (locale === "hi") return hi_err_unknown_org(inputs)
	if (locale === "ar") return ar_err_unknown_org(inputs)
	if (locale === "ms") return ms_err_unknown_org(inputs)
	if (locale === "bn") return bn_err_unknown_org(inputs)
	if (locale === "zh-TW") return zh_tw2_err_unknown_org(inputs)
	if (locale === "zh-HK") return zh_hk2_err_unknown_org(inputs)
	if (locale === "ur") return ur_err_unknown_org(inputs)
	if (locale === "fa") return fa_err_unknown_org(inputs)
	if (locale === "sw") return sw_err_unknown_org(inputs)
	if (locale === "nl") return nl_err_unknown_org(inputs)
	return en_err_unknown_org(inputs)
});